import { Handlers, Marlin } from '@zg-rentals/marlin';
import { createClient } from '@zg-rentals/http-client';

export class MarlinBrowser extends Marlin {
  constructor(appName: string) {
    super(appName, () => createClient({ logging: false, monitoring: false }), Handlers.referer, 1_000);
  }
}
